import React, { FC, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { DirRegion, useRegionsQuery } from '../../api';
import { ForeignCitiesFilter, RegionsFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const { push } = useHistory();
  const access = usePermission('directory', 'regions');
  const { data } = useRegionsQuery({ variables: { skip: page * 10, first: PER_PAGE, filter } });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'fullName',
      options: {
        display: false,
      },
    },
    {
      name: 'id',
      label: 'Название',
      options: {
        sort: false,
        customBodyRender: (value: Pick<DirRegion, 'id'>, meta) => {
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/region/${value}`}
                >
                  {meta.rowData[0]}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },

    {
      name: 'shortName',
      label: 'Краткое название',
      options: {
        sort: false,
      },
    },
    {
      name: 'dirFederalDistrict',
      label: 'Федеральный округ',
      options: {
        sort: false,
        customBodyRender: (value: any, meta) => {
          return value.label;
        },
      },
    },
  ];

  return (
    <MainTemplate pageName="Регионы" url="">
      <RegionsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Регионы</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/region/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={(data && data.dirRegions) || []}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count: data && data.count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
